import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { FirebaseAppProvider } from 'reactfire';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { firebaseConfig } from './FirebaseConfig';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<FirebaseAppProvider firebaseConfig={firebaseConfig} suspense>
			<App />
		</FirebaseAppProvider>
	</React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();
